module.exports = __webpack_public_path__ + "img/Cinema.921ac04e.jpg";